import React, { Component, useEffect, useState } from 'react';
import MaterialPage from './material.page';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import RecebimentoMaterialApi from './material.api';
import WebapiCommon from '../../../../app/common/util/webapi.common';
import * as actions from './material.action';
import * as commonActions from '../../../../app/common/common.action';
import { acessoPermitido } from '../../../../acessos.seguranca';
import * as acessos from '../../../../acessos.const.util';
import { statusEtapasEnum, etapasEnum } from '@common/util/defaultValues';
import CommonFunctions from '@util/functions.common';
import { ordemSugeridaEtapas } from '../etapas.common.util';
import IntlMessage from '../../../../helpers/intlMessage';
import cloneDeep from 'lodash/cloneDeep';
import LaudoApi from '../../../laudo/laudo.api';

function MaterialContainer(props) {

  const [modalFinalizarSemAmostra, setmodalFinalizarSemAmostra] = useState(false);
  const [modalNumeroExterno, setmodalNumeroExterno] = useState(false);
  const [msgModalFinalizarSemAmostra, setmsgModalFinalizarSemAmostra] = useState('');
  const [modalChecklist, setmodalChecklist] = useState(true);
  const altura = window.innerHeight - props.altura - 214;
  const totalVinculados = props.totalVinculados - 1;
  const { activeTab } = props;
  const [agruparExames, setAgruparExames] = useState(false);
  const microAplicavel = props.detalhes.etapas.find(x => x.etapa == "MICRO").status !== "naoaplicavel";

  useEffect(() => {
    props.actions.showFadeCarregando(true);
    props.actions.preencherExamesEmAberto([]);

    Promise.all([
      RecebimentoMaterialApi.getConfiguracoesRecebimentoMaterial(),
      WebapiCommon.getTopografias(),
      WebapiCommon.getTotalNaoConformidades(props.laudoSelecionado.laudo),
      WebapiCommon.getTotalExamesEmAberto(props.laudoSelecionado.prontuario, props.laudoSelecionado.laudo),
      WebapiCommon.getTotalExamesFinalizados(props.laudoSelecionado.prontuario),
      WebapiCommon.getFrascos(props.laudoSelecionado.laudo),
      WebapiCommon.getMedicos()
    ]).then(response => {
      var materialEtapa = props.detalhes.etapas.find(e => e.etapa === etapasEnum.MATERIAL);

      props.actions.recebimentoFinalizado(
        materialEtapa.status === statusEtapasEnum.REALIZADO ||
        (materialEtapa.status === statusEtapasEnum.NAO_CONFORMIDADE && materialEtapa.dataEtapa !== '')
      );
      props.actions.imprimiEtiquetaControle(response[0].imprimeEtiquetaControle);
      props.actions.exibirChecklistRecebimento(response[0].checklistRecebimento);
      props.actions.exibirTelaRecolhimento(response[0].abreTelaRastreabilidade);
      props.actions.faturarMedicoPadrao(response[0].faturarMedicoPadrao);
      props.actions.medicoExecutantePadrao(response[0].medicoExecutantePadrao);
      props.actions.atualizarTopografias(response[1]);
      props.commonActions.preencherTotalNaoConformidades(response[2]);
      props.actions.atualizarTotaisExames(response[3], response[4]);
      props.commonActions.adicionarFrasco(response[5]);
      props.actions.atualizarMedicos(response[6]);
      props.actions.mudarTabAtiva('1');
      props.actions.showFadeCarregando(false);
      setAgruparExames(response[0].agruparExames);

      if (response[0].checklistRecebimento &&
          props.detalhes.etapas.find(e => e.etapa === etapasEnum.MATERIAL).status !== statusEtapasEnum.REALIZADO) {
        RecebimentoMaterialApi.getBloqueioRecebimentoMaterial(props.detalhes.laudo).then(result => {
          props.commonActions.bloquearRecebimento(result.bloquearRecebimento);
        });
      } else {
        props.commonActions.bloquearRecebimento(false);
      }

      let medico = response[6].find(x => x.value == props.detalhes.medMicro);

      if (medico !== undefined) {
        props.actions.alterarMedicoMicroscopistaSelecionado({
          value: medico.value,
          label: medico.label,
        });
      } else {
        props.actions.alterarMedicoMicroscopistaSelecionado(null);
      }
    });
  }, [props.laudoSelecionado.prontuario])

  useEffect(() => {
    if (props.atalho && props.atalho === 'ctrl+alt+o') {
      fecharDetalhes();
      props.commonActions.preencherAtalho(undefined);
    }
  }, [props.atalho])

  function exibirChecklist() {
    return (
      props.exibirChecklistRecebimento && props.bloquearRecebimento
    );
  }
  function closeEtiqueta() {
    props.commonActions.showAlerta(
      'sucesso',
      'Recebimento de material concluido',
      1500
    );
  }

  function toggleModalRecolhimento(cancelar) {
    if (
      !cancelar &&
      props.modalRecolhimento &&
      !props.imprimiEtiquetaControle
    ) {
      props.commonActions.showAlerta(
        'sucesso',
        'Recebimento de material concluido',
        1500
      );
    }

    props.actions.exibirModalRecolhimentoLaudo(
      !props.modalRecolhimento
    );
  }

  function toggleModalChecklist() {
    setmodalChecklist(!modalChecklist)
  }

  function toggleModalNumeroExterno() {
    setmodalNumeroExterno(!modalNumeroExterno)

  }
  function toggle(tab) {
    switch (tab) {
      case '3':
        preencherExamesEmAberto();
        break;
      case '7':
        getListagemMultiplosExamesDoLaudo();
        break;
      case '9':
        obterListagemDocumentosLaudo();
        break;
      case '11':
        obterListagemRastreabilidade();
        break;
      default:
        break;
    }
    if (props.activeTab !== tab) {
      props.actions.mudarTabAtiva(tab);
    }
  }

  function obterListagemRastreabilidade() {
    props.actions.showFadeCarregando(true);
    WebapiCommon.obterListagemRastreabilidade(props.detalhes.laudo).then(
      response => {
        props.commonActions.atualizarListagemRastreabilidade(response);
        props.actions.showFadeCarregando(false);
      }
    );
  }

  function obterListagemDocumentosLaudo() {
    props.actions.showFadeCarregando(true);
    WebapiCommon.obterListagemDocumentosLaudo(props.detalhes.laudo).then(
      listagem => {
        props.commonActions.atualizarListagemDocumentosExternos(listagem);
        props.actions.showFadeCarregando(false);
      }
    );
  }

  function getListagemMultiplosExamesDoLaudo() {
    props.actions.showFadeCarregando(true);
    WebapiCommon.getListagemMultiplosExames(props.detalhes.laudo).then(
      listagem => {
        props.actions.atualizarListagemMultiplosExames(listagem);
        props.actions.showFadeCarregando(false);
      }
    );
  }

  function preencherExamesEmAberto() {
    if (props.exames.length === 0) {
      props.actions.showFadeCarregando(true);
      WebapiCommon.getExamesEmAberto(props.detalhes.prontuario, props.detalhes.laudo).then(
        exames => {
          props.actions.preencherExamesEmAberto(exames);
          props.actions.showFadeCarregando(false);
        }
      );
    }
  }

  function fecharDetalhes() {
    props.history.goBack();
    props.commonActions.adicionarFrasco([]);
    props.commonActions.adicionarNovoFrasco([]);
    props.commonActions.preenhcerHistoricoInconformidades([]);
    props.actions.preencherExamesEmAberto([]);
    props.commonActions.preencherExamesConcluidos([]);
    props.actions.atualizarListagemMultiplosExames([]);
    props.commonActions.atualizarListagemDocumentosExternos([]);
    props.commonActions.atualizarListagemRastreabilidade([]);
    props.actions.exibirModalRecolhimentoLaudo(false);
  }

  function salvar(finalizar) {
    let { topografiaselecionada, medicoMicroscopistaSelecionado, quantidadeFrascos } = props;

    if (!!topografiaselecionada && quantidadeFrascos > 0) {
      let novoFrascoPendente = [
        {
          topografiaId: topografiaselecionada.value,
          medicoId: medicoMicroscopistaSelecionado.value,
          quantidade: quantidadeFrascos
        }
      ];

      WebapiCommon.gerarFrasco(
        props.detalhes.laudo,
        novoFrascoPendente
      ).then(frascos => {
        atualizarDetalhes(props.detalhes);
        props.commonActions.adicionarNovoFrasco(frascos.data);
        props.actions.alterarQuantidadeFrascos(0);
        props.actions.alterarTopografiaSelecionada(null);
        afterSalvar(finalizar);
      });
    } else {
      atualizarDetalhes(props.detalhes);
      atualizarItemListagem(finalizar);
      afterSalvar(finalizar);
    }
  }

  function afterSalvar(finalizar) {

    if (props.recebimentoFinalizado) {
      props.commonActions.showAlerta('alerta', 'O recebimento material já foi realizado realizado', 1500);
    } else if (
      props.exibirChecklistRecebimento &&
      props.bloquearRecebimento &&
      finalizar
    ) {
      props.commonActions.showAlerta('alerta', 'Recebimento de material bloqueado', 1500);
      toggleModalChecklist();
    } else if (
      props.frascosNovos.length > 0 ||
      props.frascosGravados.length > 0
    ) {

      props.actions.showFadeCarregando(true);

      if (props.medicoMicroscopistaSelecionado && props.medicoMicroscopistaSelecionado !== undefined)
        WebapiCommon.editarMedicoResponsavelLaudo(props.detalhes.laudo, props.medicoMicroscopistaSelecionado.value, "MICRO", "medico", null);

      if (props.frascosNovos.length > 0) {
        WebapiCommon.registrarFrasco(
          props.detalhes.laudo,
          props.frascosNovos
        ).then(() => {
          WebapiCommon.getFrascos(props.detalhes.laudo).then(frascos => {
            props.commonActions.adicionarFrasco(frascos);
            props.commonActions.adicionarNovoFrasco([]);
            validarFinalizar(true, finalizar);
          });
        });
      } else {
        validarFinalizar(true, finalizar);
      }
    } else if (finalizar) {

      setmodalFinalizarSemAmostra(true);
      setmsgModalFinalizarSemAmostra(<IntlMessage id="dashboards.examDetail.finishReceivingMaterial" />)

    } else {
      validarFinalizar(false, finalizar);
    }
  }

  function finalizarSemAmostra(modal) {
    setmodalFinalizarSemAmostra(modal);
    validarFinalizar(true, true);
  }

  function validarFinalizar(recolhimento, finalizar) {
    if (!finalizar) {
      concluirRecebimento(finalizar);
    } else if (
      recolhimento &&
      props.exibirTelaRecolhimento &&
      acessoPermitido(props.usuario, acessos.Laudos) &&
      acessoPermitido(props.usuario, acessos.Recolhimento)
    ) {
      toggleModalRecolhimento(false);
    } else {
      concluirRecebimento(finalizar);
    }
  }

  function concluirRecebimento(finalizar) {
    RecebimentoMaterialApi.finalizarRecebimentoMaterial(
      props.detalhes.laudo,
      finalizar
    ).then(response => {
      props.commonActions.atualizarNumeroExameDoLaudoNaListagem(
        props.detalhes.laudo,
        response.data.numeroExame
      );

      if (finalizar) {
        atualizarItemListagem(finalizar);

        if (props.imprimiEtiquetaControle) {
          WebapiCommon.getFrascos(props.detalhes.laudo).then(frascos => {
            WebapiCommon.getDetalhes(props.detalhes.laudo).then(
              detalhes => {
                props.commonActions.adicionarNovoFrasco([]);
                props.commonActions.adicionarFrasco(frascos);
                atualizarDetalhes(detalhes);
                props.commonActions.showAlerta(
                  'sucesso',
                  <IntlMessage id="dashboards.examDetail.receiptCompletedMaterial" />,
                  1500
                );
                //Imprimir ou nao etiquetas?!

                if (props.frascosGravados.length > 0) {
                  props.actions.imprimiEtiquetaAgora(true);
                  toggle('5');
                }
                props.commonActions.showFadeCarregando(false);
              }
            );
          });
        } else {
          atualizarItemListagem(finalizar);
          fecharDetalhes();
          props.commonActions.showFadeCarregando(false);
          props.commonActions.showAlerta(
            'sucesso',
            <IntlMessage id="dashboards.examDetail.receiptCompletedMaterial" />,
            1500
          );
        }
        props.actions.recebimentoFinalizado(true);
      } else {
        WebapiCommon.getFrascos(props.detalhes.laudo).then(frascos => {
          WebapiCommon.getDetalhes(props.detalhes.laudo).then(detalhes => {
            WebapiCommon.obterStatusEtapasLaudo(props.detalhes.laudo).then(
              etapas => {
                props.commonActions.atualizarStatusDasEtapasDoLaudo(
                  etapas,
                  props.detalhes.laudo
                );
                atualizarDetalhes(detalhes);
                props.commonActions.adicionarFrasco(frascos);
                props.commonActions.adicionarNovoFrasco([]);
                props.actions.showFadeCarregando(false);
                props.commonActions.showAlerta(
                  'sucesso',
                  <IntlMessage id="dashboards.examDetail.materialSavedPending" />,
                  1500
                );
              }
            );
          });
        });
      }
    });
  }

  function goProximaEtapa() {
    let etapas = [...props.detalhes.etapas];
    let proximaEtapa = CommonFunctions.getProximaEtapaSugerida(etapas);
    let ordem = ordemSugeridaEtapas;
    props.commonActions.mudarEtapa(
      ordem.find(e => e.tab === proximaEtapa)
    );
  }

  function reabrirEtapa() {
    props.actions.showFadeCarregando(true);
    let resposta = '';
    new Promise(resolve => {
      WebapiCommon.reabrirRecebimentoMaterial(props.detalhes.laudo, props.detalhes.nrPedido, 'reabrir etapa', false).then(response => {
        if (response.data.cancelado) {
          let d = props.detalhes;
          d.dataEntradaMaterial = '';
          let listagem = getListagem();

          let lista = cloneDeep(listagem);
          const listagemIndex = lista.findIndex(
            item => item.laudo === props.detalhes.laudo
          );
          const item = lista[listagemIndex];
          const etapaIndex = item.etapas.findIndex(
            item => item.etapa === 'MATERIAL'
          );

          let status = props.detalhes.naoConformidadeMaterial
            ? 'naoconformidade'
            : 'naorealizado';

          lista[listagemIndex].etapas[etapaIndex].status = status;
          lista[listagemIndex].etapas[etapaIndex].dataEtapa = '';
          WebapiCommon.getDetalhes(props.detalhes.laudo).then(detalhes => {
            WebapiCommon.obterStatusEtapasLaudo(props.detalhes.laudo).then(
              etapas => {
                props.commonActions.atualizarStatusDasEtapasDoLaudo(
                  etapas,
                  props.detalhes.laudo
                );
                atualizarDetalhes(detalhes);
              })
          });
          props.actions.recebimentoFinalizado(false);
          props.commonActions.preencherListagem(lista);
          resposta = response.message;
        }

        resolve(response);
      })
    })

    props.actions.showFadeCarregando(false);

    props.commonActions.showAlerta(
      'sucesso',
      resposta,
      1500
    );
  }

  async function getListagem()
  {
    if (props.listagem === undefined || props.listagem.length === 0) {
     return new Promise(resolve => {
         LaudoApi.getLaudo(props.detalhes.laudo).then(response => {
          props.commonActions.preencherListagem(...response.listagem);
          resolve(response.listagem);
        });
      })
    }
    else {
      return props.listagem;
    }
  }

  async function atualizarDetalhes(detalhes) {
    let listagem = await getListagem();
    const lista = props.listagem.length> 0 ? [...props.listagem] : [...listagem];
    const posicao = lista.findIndex(
      item => item.laudo === props.detalhes.laudo
    );
    const item = lista.slice(posicao, posicao + 1)[0];
    const etapas = item.etapas;
    const _detalhes = {
      ...detalhes,
      etapas: etapas
    };
    WebapiCommon.obterStatusEtapasLaudo(item.laudo).then(etapas => {
      props.commonActions.atualizarStatusDasEtapasDoLaudo(
        etapas,
        item.laudo
      );
      props.commonActions.atualizarDetalhes({..._detalhes, etapas});
      props.commonActions.atualizarNumeroExameDoLaudoNaListagem(_detalhes.laudo, _detalhes.nrExame);
    });
  }

  async function atualizarItemListagem(finalizar) {
    let lista = await getListagem();
    let listagem = [...getListagem()];
    if (listagem === undefined || listagem.length === 0) {
      listagem = lista;
    }
    const listagemIndex = listagem.findIndex(
      item => item.laudo === props.detalhes.laudo
    );
    const item = listagem[listagemIndex];
    const etapaIndex = item.etapas.findIndex(
      item => item.etapa === etapasEnum.MATERIAL
    );
    listagem[listagemIndex].etapas[etapaIndex].status = finalizar
      ? statusEtapasEnum.REALIZADO
      : statusEtapasEnum.PENDENTE;
    listagem[listagemIndex].nrExame = props.detalhes.nrExame;
    props.actions.preencherListagem(listagem);
  }

  return (
    <MaterialPage
      history={props.history}
      usuario={props.usuario}
      detalhes={props.detalhes}
      altura={altura}
      toggle={(e) => toggle(e)}
      active={activeTab}
      totalNaoConformidades={props.totalNaoConformidades}
      totalExames={props.totalExames}
      totalVinculados={totalVinculados}
      finalizado={props.recebimentoFinalizado}
      fecharDetalhes={(e) => fecharDetalhes(e)}
      salvar={(e) => salvar(e)}
      modalRecolhimento={props.modalRecolhimento}
      modalChecklist={modalChecklist}
      modalNumeroExterno={modalNumeroExterno}
      imprimirEtiquetaControle={props.imprimiEtiquetaControle}
      closeEtiqueta={(e) => closeEtiqueta(e)}
      toggleModalRecolhimento={(e) => toggleModalRecolhimento(e)}
      toggleModalChecklist={(e) => toggleModalChecklist(e)}
      acessoPermitido={acessoPermitido}
      modalFinalizarSemAmostra={modalFinalizarSemAmostra}
      toggleModalNumeroExterno={(e) => toggleModalNumeroExterno(e)}
      msgModalFinalizarSemAmostra={msgModalFinalizarSemAmostra}
      alterStatus={(e) => setmodalFinalizarSemAmostra(e)}
      finalizarSemAmostra={(e) => finalizarSemAmostra(e)}
      exameFinalizado={props.exameFinalizado}
      validarFinalizar={(e, val) => validarFinalizar(e, val)}
      goProximaEtapa={(e) => goProximaEtapa(e)}
      reabrirEtapa={(e) => reabrirEtapa(e)}
      bloquearRecebimento={props.bloquearRecebimento}
      existeNaoConformidadeImpeditiva={
        props.detalhes &&
        props.detalhes.naoConformidadeImpeditivaMaterial
      }
      exibirChecklist={(e) => exibirChecklist(e)}
      exibirChecklistRecebimento={props.exibirChecklistRecebimento}
      agruparExames={agruparExames}
      microAplicavel = {microAplicavel}
    />
  );
};

const mapStateToProps = state => {
  return {
    usuario: state.usuario,
    detalhes: state.commonReducer.detalhes,
    altura: state.commonReducer.altura,
    atalho: state.commonReducer.atalho,
    listagem: state.commonReducer.listagem,
    laudoSelecionado: state.commonReducer.laudoSelecionado,
    exames: state.recebimentoMaterial.examesAbertos,
    vinculados: state.recebimentoMaterial.exames,
    totalNaoConformidades: state.commonReducer.totalNaoConformidades,
    totalExames: state.recebimentoMaterial.totalExamesAbertos,
    totalVinculados: state.recebimentoMaterial.totalExamesConcluidos,
    frascosNovos: state.commonReducer.frascosNovos,
    frascosGravados: state.commonReducer.frascosGravados,
    recebimentoFinalizado: state.recebimentoMaterial.recebimentoFinalizado,
    listagemMultiplosExames: state.recebimentoMaterial.listagemMultiplosExames,
    imprimiEtiquetaControle: state.recebimentoMaterial.imprimiEtiquetaControle,
    exibirChecklistRecebimento: state.recebimentoMaterial.exibirChecklistRecebimento,
    exibirTelaRecolhimento: state.recebimentoMaterial.exibirTelaRecolhimento,
    listagemDocumentosExternos: state.commonReducer.listagemDocumentosExternos,
    modalRecolhimento: state.recebimentoMaterial.modalRecolhimento,
    listagemRastreabilidade: state.commonReducer.listagemRastreabilidade,
    exameFinalizado: state.commonReducer.exameFinalizado,
    faturarMedicoPadrao: state.recebimentoMaterial.faturarMedicoPadrao,
    medicoExecutantePadrao: state.recebimentoMaterial.medicoExecutantePadrao,
    bloquearRecebimento: state.commonReducer.bloquearRecebimento,
    topografiaselecionada: state.recebimentoMaterial.topografiaselecionada,
    medicoMicroscopistaSelecionado: state.recebimentoMaterial.medicoMicroscopistaSelecionado,
    quantidadeFrascos: state.recebimentoMaterial.quantidadeFrascos,
    activeTab: state.recebimentoMaterial.activeTab
  };
};

const mapDispatchToProps = dispatch => {
  return {
    actions: bindActionCreators(actions, dispatch),
    commonActions: bindActionCreators(commonActions, dispatch)
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(MaterialContainer);



// WEBPACK FOOTER //
// ./src/pages/laudo/etapas/material/material.container.js